/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![InventoryIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABaElEQVR4nN2VO0sDURCFb8BarLURUVELGztR0kZ252EgnkksRCQg+CfSWIhgn1awFBG0t7C3EbEJ8R9oMKD4ILKioNmHG7ONDkx1Ludjzp3Lde7flVesjJHilBVtVuuka7RJcCKC0UTzfD4/QGrX6Y3tW5PYVeARCxDB4m/N+aMDj1gAq1X7BbBaNRZAglq/ABLUkiaoZzBBPQmw25XnvK/lhYS8Qzop9uIjIpslsZfPw1/AkYBunQRPqpU5l1S+YokUFwEoLYAEr6y4JIUfa+wVyxOFwuqg67NE1oaISuMhgZdtiwUN5pV1Zht2zuV68M15XmmEBBuk1mS1zTBAsfNTxpxe3w4BSO2g+2CwIUmvO0HfD08gdp7BG+i8t+AsAoCbNHvOaXRBI+IO7DnDiB5DW8CCh6wiIrH7iEsOPpmMAIrjcERcmiGxuwzMb/1iecpFlSqmWXHEilbv5mix2KEqJiPN/2y9Aa22Z8JLfKCdAAAAAElFTkSuQmCC)
 */
export const InventoryIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M6.69 2A3 3 0 0 0 3.7 4.67l-.33 3A3 3 0 0 0 6.35 11H7V9a1 1 0 0 1 2 0v2h6V9a1 1 0 1 1 2 0v2h.65a3.05 3.05 0 0 0 .9-.14 3 3 0 0 0 2.08-3.2l-.33-3A3 3 0 0 0 17.3 2H6.7Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M15 13v1a1 1 0 1 0 2 0v-1h.65c1.43 0 2.72-.6 3.62-1.56l.04.22.68 5.88A4 4 0 0 1 18 22H6A4 4 0 0 1 2 17.54l.68-5.88.04-.22c.9.96 2.19 1.56 3.62 1.56H7v1a1 1 0 1 0 2 0v-1h6Zm-6 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm7 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
